import { provide } from "vue";
import {
  injectRequiredWithSelf,
  checkValuesAlreadyProvided,
  CreateInjectionKeysRecord,
  type InjectionKeysRecord,
  type InjectionValuesRecord,
} from "@mcwd/util-vue";

import { useFormUserInputValues } from "./use-form-user-input-values.js";
import { useFormLogger } from "./use-form-logger.js";
import { PrivacyConsentState } from "../models/PrivacyConsentState.js";
import { useSiteLanguage } from "./use-site-language.js";

type UsePrivacyConsentStateInjectionValues = InjectionValuesRecord<{
  privacyConsentState: PrivacyConsentState
}>;
type  UsePrivacyConsentStateInjectionKeys = InjectionKeysRecord< UsePrivacyConsentStateInjectionValues>;
const  UsePrivacyConsentStateInjectionKeys = CreateInjectionKeysRecord< UsePrivacyConsentStateInjectionKeys>({
  privacyConsentState: "privacyConsentState",
});



export function initPrivacyConsentState() {
  if (checkValuesAlreadyProvided(UsePrivacyConsentStateInjectionKeys)) {
    return;
  }
  const { logger } = useFormLogger({ callerLabel: "initPrivacyConsentState" });
  const { siteCountryCode } = useSiteLanguage({ callerLabel: "initPrivacyConsentState" });
  const { userInputValues } = useFormUserInputValues({ callerLabel: "initPrivacyConsentState" });
  const privacyConsentState = new PrivacyConsentState({ siteCountryCode, userInputValues: () => userInputValues, logger });

  provide( UsePrivacyConsentStateInjectionKeys.privacyConsentState, privacyConsentState);
}

export function usePrivacyConsentState({ callerLabel }: { callerLabel?: string | undefined } = {}) {
  const { logger } = useFormLogger({ callerLabel: "usePrivacyConsentState" });
  try {
    callerLabel ??= "usePrivacyConsentState";

    const privacyConsentState = injectRequiredWithSelf( UsePrivacyConsentStateInjectionKeys.privacyConsentState);
    return { privacyConsentState };
  } catch (err) {
    logger.error(`InjectionError from ${callerLabel ?? "unknown"}`);
    throw err;
  }
}
